
// frontend/geopolitikia/src/hooks/useImpacts.js
import { useMemo } from 'react';

const useImpacts = (gameState) => {
  const groupImpactsByParam = (impacts) => {
    const grouped = {};
    impacts.forEach((impact) => {
      if (!grouped[impact.param]) {
        grouped[impact.param] = [];
      }
      grouped[impact.param].push(impact);
    });
    return grouped;
  };

  const impactsByParam = useMemo(() => {
    if (!gameState || !gameState.impacts) return {};
    return groupImpactsByParam(gameState.impacts);
  }, [gameState]);

  return impactsByParam;
};

export default useImpacts;
